import type { LockedContent } from '../../types/app';
import { getCategoryAncestorsLockState } from './ancestors';
import { LockStates } from '~/types/adamTypes';

export type CategoryLockState = {
  isTypeQuizLocked: boolean;
  isTypePostLocked: boolean;
  isTypeExerciseLocked: boolean;
  getIsTypeLocked: (type) => boolean;
  ancestorsLockState: LockStates;
};

const _getIsTypeLocked = (
  type: string,
  isASubscriber: boolean,
  hasCategoryLockState: boolean,
  isCategoryLocked: boolean,
  isMainOrPreviousContent: boolean,
  lockedContent: LockedContent
) => {
  if (isASubscriber) return false;
  if (hasCategoryLockState) {
    return isCategoryLocked;
  } else {
    if (lockedContent[type] == null) return false;
    if (!isMainOrPreviousContent) return true;
    return lockedContent[type] ?? false;
  }
};

export const getCategoryLockStates = (
  isASubscriber,
  content: UserContent,
  ancestors: CategorySchema[],
  profilleLockedContent: any
): CategoryLockState => {
  const isMainOrPreviousContent =
    content.type === UserContentType.MainContent ||
    content.type === UserContentType.PreviousContent;

  const ancestorsLockState = getCategoryAncestorsLockState(ancestors);

  const hasCategoryLockState = ancestorsLockState !== LockStates.Default;

  const isCategoryLocked = ancestorsLockState === LockStates.Locked;

  const getIsTypeLocked = (type) => {
    return _getIsTypeLocked(
      type,
      isASubscriber,
      hasCategoryLockState,
      isCategoryLocked,
      isMainOrPreviousContent,
      profilleLockedContent
    );
  };

  const isTypeQuizLocked = getIsTypeLocked('quiz');

  const isTypePostLocked = getIsTypeLocked('post');

  const isTypeExerciseLocked = getIsTypeLocked('exercise');

  return {
    isTypeQuizLocked,
    isTypeExerciseLocked,
    isTypePostLocked,
    getIsTypeLocked,
    ancestorsLockState,
  };
};
